/**
 * Module dependencies.
 */

import {
  acceptLanguageHeader,
  handleRequestError,
  request
} from 'src/core/utils/requests';

import { availableFiltersKeys } from 'src/core/content-config/model-ranges';
import { getApiEndpoint } from 'src/core/utils/api-url-resolver';
import isEmpty from 'lodash/isEmpty';
import merge from 'lodash/merge';
import omit from 'lodash/omit';

/**
 * `Query` type.
 */

type Query = {
  locale: string;
  params: {
    filter?: {
      [key: string]: any;
    };
    limit: number;
    page: number;
    sort?: string;
  };
  technologyId: string;
};

/**
 * Export `paginationLimit` constant.
 */

export const paginationLimit = 20;

/**
 * Export `fetchModelRanges`.
 */

export async function fetchModelRanges(query: Query) {
  const { locale, params, technologyId } = query;
  const endpoint = getApiEndpoint('getModelRanges');

  if (!params.page) {
    return;
  }

  try {
    const currentPage = params?.page ?? 1;
    const { data } = await request.get(endpoint, {
      headers: acceptLanguageHeader(locale),
      params: {
        ...omit(params, ['filter']),
        filter: merge({}, { technology: technologyId }, params?.filter),
        sort: isEmpty(params?.sort)
          ? availableFiltersKeys.waterCapacity
          : params?.sort
      }
    });

    return {
      data: data?.data,
      nextPage: +currentPage + 1,
      total: data?.total
    };
  } catch (error) {
    handleRequestError(error);
  }
}
